import './AllSetStyles.less';

import OrderedListItem from './OrderedListItem';

import { Icon } from '@opendoor/bricks';
import React, { Component } from 'react';

interface IProps {
  acqCxLeadPhoneNumber: string;
}

class AllSet extends Component<IProps> {
  public render() {
    return (
      <div className="od-brokerage-offer-flow-complete regular-container text-center xxl-margin-top">
        <Icon name="check-filled" className="small-margin-bottom" />
        <h1 className="huge-headline medium-margin-top large-margin-bottom">You're all set</h1>
        {this.renderWhatHappensNext()}
        {this.renderContactUs()}
      </div>
    );
  }

  private renderWhatHappensNext() {
    const listItems = [
      {
        description: `We'll work with our Trusted Buyer Partner to create a customized Purchase Agreement for your
                      home.`,
        headline: "We'll prepare your purchase agreement.",
      },
      {
        description: 'Within a day, you should receive an e-sign document for your convenience.',
        headline:
          'Within a day, you should receive an email containing a purchase agreement for your home.',
      },
      {
        description: `Once we've received your signed Purchase Agreement, we'll reach out with next steps to
                      complete the closing process`,
        headline: 'Be sure to review the Purchase Agreement before your offer expires.',
      },
    ];

    return (
      <div className="xl-margin-bottom">
        <h2 className="xl-margin-bottom">Here's what happens next</h2>
        <div className="row">
          <div className="col-lg-offset-1 col-lg-10">
            <ol className="od-what-happens-next-list text-left">
              {listItems.map(this.renderListItem)}
            </ol>
          </div>
        </div>
      </div>
    );
  }

  private renderListItem(listItem, idx) {
    const { headline, description } = listItem;
    return (
      <li className="list-item" key={headline}>
        <OrderedListItem index={idx + 1}>
          <h6 className="small-margin-bottom">{headline}</h6>
          <p>{description}</p>
        </OrderedListItem>
      </li>
    );
  }

  private renderContactUs() {
    return (
      <div className="od-brokerage-offer-contact-us xxl-margin-bottom">
        <h2 className="questions-or-concerns-header smallcaps-headline medium-margin-bottom">
          Questions or concerns?
        </h2>
        <h2 className="xl-margin-bottom">Contact us</h2>
        <p>
          If you have any questions or concerns, please reach out to us at&nbsp;
          <a href="mailto:transactions@opendoor.com">transactions@opendoor.com</a> or&nbsp;
          {this.props.acqCxLeadPhoneNumber} and we'll get your questions handled promptly.
        </p>
      </div>
    );
  }
}

export default AllSet;
